import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXLandingPageDocumentation implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxLandingPageDocumentationContainer";
    }
    render(){
        console.log("landing page documentation");
        this.zidx.runLoadFunctions();
    }
}